import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';
import { querySelector } from '../../../../utils';
import queryMetaHandler from '../../../../utils/queryMetaHandler';
import omitProps from '../../../../utils/omitProps';

export const LeaseListFragment = gql`
  fragment LeaseList on LeaseLookupResult {
    id: user_id
    name
    lookupStatus: lookup_status
    lease {
      id
      name
      customer {
        id
        display_name
        customer_name
      }
      tax_schedule {
        id
        description
        tax_schedule_number
        display_name
      }
      operator {
        id
        name
      }
    }
  }
`;

export const GetAllLeasesQuery = gql`
  query GetAllLeases {
    all_leases: lookup_leases(lookup_query: {join_type: user_records}) {
      edges {
        node {
          ...LeaseList
        }
      }
    }
  }
  ${LeaseListFragment}
`;

const marshallUserData = ({ ownProps, data }) => {
  const leaseList = querySelector(data, '$.all_leases.edges[*].node', []);
  return {
    ...ownProps,
    leaseList,
    data,
  };
};


const queryLeaseData = graphql(GetAllLeasesQuery, {
  props: marshallUserData,
});

export const queryLeaseGQL = compose(
  queryLeaseData,
  queryMetaHandler,
  omitProps(['data']),
);

const UpdateLeaseMutation = gql`
  mutation UpdateLease($input : LeaseUpdateInput!) {
    lease_update(input : $input) {
      id
      name
      operator {
        id
        name
      }
       customer {
        id
        display_name
        customer_name
      }
      tax_schedule {
        id
        tax_schedule_number
        display_name
      }
    }
  }
`;

export const updateLeaseMutationGQL = (client, lease, customerId, taxScheduleId) => {
  const variables = {
    input: {
      id: lease.id,
      name: lease.name,
      customer_id: customerId,
      tax_schedule_id: taxScheduleId,
    },
  };

  const options = {
    mutation: UpdateLeaseMutation,
    variables,
    refetchQueries: [
      { query: GetAllLeasesQuery },
    ],
  };
  return client.mutate(options);
};
